import { VideoService } from './../services/video.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  private categories = [];

  constructor(
    private videoService: VideoService,
  ) { 
    console.log("dashboard")
    this.videoService.getVideoList().then((categories:Array<any>)=>{
      this.categories = categories;
      console.log(this.categories)
    })
    
    console.log(this.categories)   
  }

  ngOnInit() {

      console.log(this.categories);
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.component.ts